import * as React from "react";
import "./styles.scss";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const dotArrow = require("../../assets/icon/dot_arrow.svg").default;

const CancelSubscription = () => {
    return (
        <section className="cancel-subscription">
            <div className="cancel-flow">
                <div>
                    iPhoneの設定から
                    <br />
                    ご自身のユーザーアカウントを選択
                </div>
                <div className="sign-in-hint">
                    サインイン画面が表示された場合は、パスワード入力、またはTouch
                    ID（指紋認証）やFace ID（顔認証）でサインインします。
                </div>
                <div className="arrow-wrapper">
                    <img src={dotArrow} alt="arrow down" />
                </div>
                <div>サブスクリプションを選択</div>
                <div className="arrow-wrapper">
                    <img src={dotArrow} alt="arrow down" />
                </div>
                <div>パートナーエージェントAppを選択</div>
                <div className="arrow-wrapper">
                    <img src={dotArrow} alt="arrow down" />
                </div>
                <div>
                    サブスクリプションの編集から
                    <br />
                    <span className="emphasis">
                        サブスクリプションをキャンセルする
                    </span>
                    を選択
                    <br />
                    （継続の場合は停止予定のプランを選択）
                </div>
            </div>
            <aside className="no-solve">
                <div>
                    上記のフローで解決しない場合
                    <br />
                    <a
                        href="https://support.apple.com/ja-jp/HT202039"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Appleのサポートページ
                    </a>
                    をご参照ください
                </div>
            </aside>
        </section>
    );
};

export default CancelSubscription;
